module.exports = " <div class=la-ball-fall> <div></div> <div></div> <div></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/common/loadingindicator/template.html
// module id = 41
// module chunks = 0